import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { APP_CONFIG } from './core/config/app-config.token';
import { apiKeyInterceptor } from './data/http/api-key.interceptor';
import { provideDataLayer } from './data/data.providers';
import { provideI18n } from './presentation/shared/i18n/i18n.providers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([apiKeyInterceptor])),
    { provide: APP_CONFIG, useValue: environment },
    provideDataLayer(),
    provideI18n(),
  ],
};
